export default __webpack_public_path__ + "static/media/mobile demand.fc085401.png";